import { observable, action, toJS } from "mobx";
import { FirebaseDocument } from "common/models/FirebaseDocument";
import { ModelMap } from "modules/modelMap/models/ModelMap";
import i18n from "i18n";
import * as _ from "lodash";
import BaseStore from "../../common/BaseStore";
import TakeOffItemsSaving from "./models/takeOffItemsSaving";
import { ModelMapStore } from "../modelMap/ModelMapStore";
import { TakeOffFormatedItem } from "modules/takeOff/models/TakeOffFormatedItem";
import { TakeOffService } from "modules/takeOff/TakeOffService";
import { WBSStore } from "modules/WBS/WBSStore";
import { LibraryStore } from "modules/library/LibraryStore";
import { LibraryService } from "modules/library/LibraryService";
import { Render3dStore } from "modules/render3D/Render3dStore";
import { Render3dService } from "modules/render3D/Render3dService";
import { ProjectStore } from "modules/project/ProjectStore";
import { EModelMapTab, EModelMapType, ERowType } from "common/enums";

class Store extends BaseStore {
  @observable takeOffItems: any[] = new Array();
  @observable takeOffFilteredItems: any[] = new Array();
  @observable layerTakeOffList: boolean = false;
  @observable layerTakeOffEdit: string = "";
  @observable takeOffLoading: boolean = false;
  @observable takeOffSaveformate: boolean = false;
  groupDataModelMap: any;
  @observable takeOffModelMap: FirebaseDocument<ModelMap> | undefined;
  @observable takeOffColumns: any[] = new Array();
  @observable selectedColumn: any;
  @observable searchMaterialOrMaterial: any;
  @observable searchMaterialOrMaterialLength: number = 0;
  @observable firstFilter: any = -1;
  @observable secondFilter: any = -1;
  @observable firstFilterValue: string = "";
  @observable secondFilterValue: string = "";
  @observable selectedRadio: string = "";
  @observable swipeTab: EModelMapTab = EModelMapTab.CONFIGURATION;
  @observable swipeTabComposition: number = 0;
  @observable isFormating: boolean = true;
  @observable takeOffFormatedList: any[] = new Array();
  @observable statusModelmap: string = "";
  @observable hasErrorFilter: boolean = false;
  @observable savingTakeOffItems: TakeOffItemsSaving[] = [];
  @observable openSnack: boolean = false;
  @observable listSelect: { rowId: number; selected: boolean }[] = new Array();
  @observable loadingTakeOff: boolean = false;

  constructor() {
    super("TakeOffStore");
  }

  clearTakeOffModelMap() {
    if (
      TakeOffStore.takeOffModelMap &&
      TakeOffStore.takeOffModelMap.data.formatErrors === undefined
    ) {
      delete TakeOffStore.takeOffModelMap.data.formatErrors;
    }
    if (
      TakeOffStore.takeOffModelMap &&
      TakeOffStore.takeOffModelMap.data.filterErrors === undefined
    ) {
      delete TakeOffStore.takeOffModelMap.data.filterErrors;
    }
    if (
      TakeOffStore.takeOffModelMap &&
      TakeOffStore.takeOffModelMap.data.modelErrors === undefined
    ) {
      delete TakeOffStore.takeOffModelMap.data.modelErrors;
    }
    if (
      TakeOffStore.takeOffModelMap &&
      TakeOffStore.takeOffModelMap.data.categoryErrors === undefined
    ) {
      delete TakeOffStore.takeOffModelMap.data.categoryErrors;
    }
    if (
      TakeOffStore.takeOffModelMap &&
      TakeOffStore.takeOffModelMap.data.warning === undefined
    ) {
      delete TakeOffStore.takeOffModelMap.data.warning;
    }
    this.listSelect.forEach((element) => {
      element.selected = false;
    });
  }

  getIsSaving(
    savingTakeOffItems: TakeOffItemsSaving[],
    modelMap: FirebaseDocument<ModelMap> | undefined
  ): TakeOffItemsSaving | undefined {
    if (
      modelMap !== null &&
      modelMap !== undefined &&
      this.savingTakeOffItems !== null &&
      this.savingTakeOffItems !== undefined
    ) {
      return savingTakeOffItems.filter((x) => x.modelMap.id == modelMap.id)[0];
    }

    return undefined;
  }

  @action
  resetStore() {
    this.takeOffItems = new Array();
    this.takeOffFilteredItems = new Array();
    this.layerTakeOffList = false;
    this.takeOffLoading = false;
    this.takeOffModelMap = undefined;
    this.takeOffColumns = new Array();
    this.selectedColumn = undefined;
    this.firstFilter = -1;
    this.secondFilter = -1;
    this.firstFilterValue = "";
    this.secondFilterValue = "";
    this.selectedRadio = "";
    this.swipeTab = EModelMapTab.CONFIGURATION;
    this.isFormating = true;
    this.swipeTabComposition = 0;
    this.takeOffFormatedList = new Array();
    this.listSelect = new Array();
  }

  @action
  setLoadingTakeOff(value) {
    this.loadingTakeOff = value;
  }

  @action
  setTakeOffLoading(value: boolean) {
    this.takeOffLoading = value;
  }

  @action
  setSearchElementOrMaterial(value) {
    this.searchMaterialOrMaterial = value;
  }

  @action
  setSearchElementOrMaterialLength(value) {
    this.searchMaterialOrMaterialLength = value;
  }

  @action
  setColumnFilterProperties(column): void {
    let filters =
      TakeOffStore.takeOffModelMap !== undefined &&
      TakeOffStore.takeOffModelMap.data.filters !== undefined
        ? _.filter(TakeOffStore.takeOffModelMap.data.filters, function (obj) {
            return obj.field === column;
          })
        : new Array();

    filters = _.orderBy(filters, ["logicalOperator"], ["asc"]);

    this.firstFilter = -1;
    this.secondFilter = -1;
    this.firstFilterValue = "";
    this.secondFilterValue = "";
    this.selectedRadio = "";

    let filterIndex = 0;
    for (const filter of filters) {
      if (filterIndex === 0) {
        this.firstFilter = filter.operation;
        this.firstFilterValue = filter.operationValue;
      } else {
        this.secondFilter = filter.operation;
        this.secondFilterValue = filter.operationValue;
        this.selectedRadio = filter.logicalOperator;
      }
      filterIndex += 1;
    }
  }

  getFormatLevel(parentListIndex): number {
    let level = 0;
    let takeOffModelMap: any = TakeOffStore.takeOffModelMap;
    let indexSelected = TakeOffStore.takeOffFormatedList.findIndex(
      (i) => i.id == takeOffModelMap.id
    );

    let takeOffFormatedList = TakeOffStore.takeOffFormatedList[indexSelected]
      ? TakeOffStore.takeOffFormatedList[indexSelected].data
      : new Array();

    if (parentListIndex === -1 || parentListIndex === undefined) return level;
    while (parentListIndex >= 0) {
      level += 1;

      let parent = _.find(takeOffFormatedList, function (f) {
        return f.listIndex === parentListIndex;
      });
      parentListIndex = parent !== undefined ? parent.parentListIndex : -1;
    }
    return level;
  }

  public setPrimaryTakeOffItens(
    takeOffItems: any[],
    takeOffColumns: string[],
    takeOffFilteredItems: any[],
    takeOffModelMap: any
  ) {
    this.takeOffModelMap = takeOffModelMap;
    this.takeOffItems = takeOffItems;
    this.takeOffColumns = takeOffColumns;
    this.takeOffFilteredItems = takeOffFilteredItems;
  }

  @action
  public addQuantityFromTakeOffItem(tkoItem: TakeOffFormatedItem) {
    if (
      WBSStore.selectedLine.data.rowType !== ERowType.BLANK &&
      WBSStore.selectedLine.data.rowType !== ERowType.STAGE &&
      (!WBSStore.selectedLine.data.fromModelMap ||
        WBSStore.selectedLine.data.takeOffQuantity)
    ) {
      WBSStore.handleWBSTableChange(
        WBSStore.selectedLine,
        WBSStore.selectedLine.index,
        "row",
        "formula",
        "",
        "",
        "",
        "",
        "",
        true
      );
      TakeOffService.addCostPlain(tkoItem.modelMapId);
      let qttOrigin = new Array();
      qttOrigin.push(tkoItem.description);
      let parentIndex = tkoItem.parentListIndex;

      let indexSelected = TakeOffStore.takeOffFormatedList.findIndex(
        (i) => i.id == tkoItem.modelMapId
      );

      let takeOffFormatedList = TakeOffStore.takeOffFormatedList[indexSelected]
        ? [...TakeOffStore.takeOffFormatedList[indexSelected].data]
        : new Array();

      while (parentIndex >= 0) {
        let parentTkoItem = takeOffFormatedList[parentIndex];
        qttOrigin.push(parentTkoItem.description);
        parentIndex = parentTkoItem.parentListIndex;
      }

      let qttValue = Math.round(tkoItem.resultQuantity * 100) / 100;

      WBSStore.handleWBSTableChange(
        WBSStore.selectedLine,
        WBSStore.selectedLine.index,
        "row",
        "quantity",
        qttValue,
        "takeOffQuantity",
        qttOrigin,
        "fromModelMap",
        tkoItem.modelMapId,
        true
      ).then(() => {
        this.checkAddedQuantityLinkFromTakeOff();
      });
    }
  }

  hasTakeOffPath = () => {
    const { selectedLine } = WBSStore;
    let hasPath =
      selectedLine &&
      selectedLine.data &&
      selectedLine.data.takeOffQuantity &&
      selectedLine.data.takeOffQuantity.length >= 1;
    return hasPath;
  };

  checkAddedQuantityLinkFromTakeOff = (checkCount: number = 0) => {
    let hasPath = this.hasTakeOffPath();
    if (!hasPath && checkCount < 30) {
      setTimeout(
        () => this.checkAddedQuantityLinkFromTakeOff(checkCount++),
        500
      );
    } else {
      WBSStore.setSelectedLine(WBSStore.selectedLine.index, "quantity");
    }
  };

  @action
  public async removeQuantityLinkWithTakeOffItem(oldValue = undefined) {
    if (
      WBSStore.selectedLine.data.fromModelMap &&
      WBSStore.selectedLine.data.takeOffQuantity &&
      WBSStore.selectedLine.data.takeOffQuantity.length > 0
    ) {
      if (oldValue) {
        await WBSStore.handleWBSTableChange(
          WBSStore.selectedLine,
          WBSStore.selectedLine.index,
          "row",
          "quantity",
          oldValue,
          "takeOffQuantity",
          undefined,
          "fromModelMap",
          undefined,
          true,
          true
        );
      } else {
        await WBSStore.handleWBSTableChange(
          WBSStore.selectedLine,
          WBSStore.selectedLine.index,
          "row",
          "takeOffQuantity",
          undefined,
          "fromModelMap",
          undefined,
          "",
          "",
          true
        );
      }
      await WBSStore.removeCostPlanLink(
        WBSStore.selectedLine.data.fromModelMap
      );
      WBSStore.setSelectedLine(WBSStore.selectedLine.index, "quantity");
    }
  }

  @action
  setLayerToAddModelMap() {
    this.layerTakeOffList = true;
    this.layerTakeOffEdit = "add";
  }

  @action
  setLayerToEditModelMap() {
    this.layerTakeOffEdit = "";
    this.setSwipeTab(EModelMapTab.CONFIGURATION);
  }

  setModelMapToFilter() {
    TakeOffStore.layerTakeOffEdit = "";
    this.setSwipeTab(EModelMapTab.FILTER);
  }

  verifyItensAndSetTakeOffFormated(modelMapId: string) {
    this.setTakeOffSaveformate(false);

    const list = this.takeOffFormatedList.find(
      (list) => list.id === modelMapId
    );
    const emptyList = list ? list.data.length === 0 : false;
    if (emptyList) {
      TakeOffStore.openSnack =
        i18n.modelMaps.takeOffLayer.formulaWithNoQuantity;
    }
  }

  setTakeOffSaveformate(value: boolean) {
    this.takeOffLoading = value;
    this.takeOffSaveformate = value;
  }

  @action
  setSwipeTab(tab: EModelMapTab) {
    this.swipeTab = tab;
  }

  /** Action que limpa listas e várias variáveis do takeOff. */
  @action
  resetTakeOffProperties() {
    this.takeOffItems = [];
    this.takeOffFilteredItems = [];
    this.takeOffColumns = [];
    this.listSelect = [];
    this.takeOffFormatedList = [];
    this.takeOffModelMap = undefined;
    this.layerTakeOffList = true;
    this.isFormating = true;
    this.selectedColumn = undefined;
    this.setSwipeTab(EModelMapTab.CONFIGURATION);
  }

  @action
  resetWhenDeleteModelMap() {
    this.layerTakeOffList = false;
    this.setSwipeTab(EModelMapTab.CONFIGURATION);
  }

  @action
  updateFilterAndField() {
    if (this.takeOffModelMap) {
      this.takeOffModelMap.data.fields = [];
      this.takeOffModelMap.data.filters = [];
    }
  }

  arrowEnable = () => {
    if (this.swipeTab === EModelMapTab.FILTER || !this.isFormating)
      return false;
    if (ModelMapStore.selectedFormatLine != undefined) return true;
    return false;
  };

  setSelectedColumn(column, index, target) {
    this.hasErrorFilter = false;

    const clmn = this.selectedColumn;
    if (clmn && clmn.headerCell !== null) {
      clmn.headerCell.style.backgroundColor = "unset";
    }

    this.selectedColumn = { index: index, column: column, headerCell: target };
    this.setColumnFilterProperties(column);

    if (this.selectedRadio == "") {
      this.selectedRadio = "and";
    }
  }

  async isolateItemsFromTakeOff() {
    Render3dStore.resetViewer();
    if (this.takeOffFilteredItems.length > 0) {
      const mapFiles = _.uniq(
        this.takeOffFilteredItems.map((item) => item.file.id)
      );
      const availableIFCs = LibraryStore.libraries3DEnabled.map((ifc) =>
        ifc.replace("sw_", "")
      );

      // Verifica e habilita os modelos desabilitados utilizados no model-map
      const invisibleLibraries = _.difference(mapFiles, availableIFCs);
      await this.enableInvisibleLibraries(invisibleLibraries);
    }

    setTimeout(() => {
      Render3dStore.setItemsToIsolate().then(() => WBSStore.openViewer3D());
    }, 500);
  }

  private async enableInvisibleLibraries(invisibleLibraries: any[]) {
    if (invisibleLibraries.length > 0) {
      for (const ifcId of invisibleLibraries) {
        const lib = LibraryStore.findLibrayById(ifcId);
        if (lib) await LibraryService.toggleRenderLibrary(lib);
      }

      await LibraryStore.changeLibrariesVisibility();
    }

    this.layerTakeOffList = false;
    Render3dStore.setIsolateArray(this.getIsolateItems());
  }

  private getIsolateItems() {
    let isolateArray = new Array();

    for (let i = 0; i < this.takeOffFilteredItems.length; i++) {
      let takeOff = this.takeOffFilteredItems[i];

      if (this.listSelect[i].selected) {
        if (takeOff) {
          let idx = isolateArray.findIndex((i) => i.modelId == takeOff.file.id);
          if (idx == -1) {
            isolateArray.push({
              modelId: takeOff.file.id,
              GUID: [takeOff.GUID],
            });
          } else {
            isolateArray[idx].GUID.push(takeOff.GUID);
          }
        }
      }
    }
    return isolateArray;
  }

  findFormatedListByModelMapId(modelMapId: string) {
    const list = this.takeOffFormatedList.find((t) => t.id == modelMapId);
    return list ? list.data : [];
  }

  @action
  checkAllTakeOffItems(checked: boolean) {
    const newLista = [...this.listSelect];
    for (const item of newLista) {
      item.selected = checked;
    }
    this.listSelect = newLista;
  }

  checkSelectedItemOfTakeOff(index: number, checked: boolean) {
    const newLista = [...this.listSelect];
    newLista[index].selected = checked;
    this.listSelect = newLista;
  }

  getTakeOffSelectedLength() {
    const list = this.listSelect.filter((el) => el.selected);
    if (list.length > this.takeOffFilteredItems.length)
      return this.takeOffFilteredItems.length;
    return list.length;
  }

  async fetchTakeOffFormatedList(
    modelMap?: FirebaseDocument<ModelMap>,
    getById?: string,
    canSwipeTab: boolean = true
  ) {
    if (!modelMap) modelMap = this.takeOffModelMap;
    await TakeOffService.fetchTakeOffFormatedItemsFromDataBase(
      modelMap,
      getById,
      (modelMapId, list) => {
        const emptyList = list.length === 0;
        this.setTakeOffFormatedList(modelMapId, list);

        if (this.takeOffModelMap) {
          if (this.takeOffModelMap.id == modelMapId) {
            this.isFormating = emptyList;
            if (canSwipeTab) {
              this.setSwipeTab(
                emptyList && !ModelMapStore.modelMapFormat.length
                  ? EModelMapTab.FILTER
                  : EModelMapTab.FORMATING
              );
            }
          }
        }
        // Quando é aberta a edição do take off a partir da função handleOpenTakeOff
        // o loading deve ser sempre fechado para que o usuário visualize as informações
        this.takeOffLoading = false;
      }
    );

    if (!getById && modelMap) {
      if (modelMap.data.type === EModelMapType.ELEMENT_CONSTRUCTIVE) {
        ModelMapStore.fetchModelMapProperties(
          EModelMapType.ELEMENT_CONSTRUCTIVE
        );
      } else {
        ModelMapStore.fetchModelMapProperties(EModelMapType.MATERIAL);
      }
    }
  }

  private setTakeOffFormatedList(
    modelMapUid: string,
    updatedList: TakeOffFormatedItem[]
  ) {
    const idx = this.takeOffFormatedList.findIndex((i) => i.id == modelMapUid);
    if (idx === -1) {
      this.takeOffFormatedList.push({
        id: modelMapUid,
        data: [...updatedList],
      });
    } else {
      this.takeOffFormatedList[idx].data = [...updatedList];
    }
  }
}

let TakeOffStore = new Store();

export { TakeOffStore };



// WEBPACK FOOTER //
// ./src/modules/takeOff/TakeOffStore.ts